// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"69a5e8d8","239":"ad40150f","453":"54292a4b","667":"fbbf706a"}[chunkId] + ".chunk.js";
};